import { getCountry, getBrowserPlatform } from "@/utils/common.js";
const app = {
  namespaced: true,
  state: {
    transitionName: "slide-left",
    lang: "", // "zh-CN", "en-US"
    country: getCountry(), // china | my
    currencyUnit: "", // 元
    currencySymbol: "", // ￥
    separator: "", // 千位分隔符
    decimalPlaces: "2", // 小数位数
    userAuthToken: localStorage.getItem("authtoken") || "",
    browserPlatform: getBrowserPlatform(),
    cachesRoutes: [], // 需要添加keepAlive缓存的路由
    platform: "", // 平台
    realPlatform: "" // app返回的平台(GT、GT_RADIAL、MiXED)
  },
  getters: {},
  mutations: {
    setTransitionName(state, name) {
      state.transitionName = name;
    },
    setLang(state, lang) {
      state.lang = lang;
    },
    setCurrencyUnit(state, data) {
      state.currencyUnit = data;
    },
    setCurrencySymbol(state, data) {
      state.currencySymbol = data;
    },
    setDecimalPlaces(state, data) {
      state.decimalPlaces = data;
    },
    setSeparator(state, data) {
      state.separator = data;
    },
    setCachesRoutes(state, data = []) {
      state.cachesRoutes = data;
    },
    removeCachesRoutes(state, name) {
      state.cachesRoutes = state.cachesRoutes.filter(n => n !== name);
    },
    addCachesRoutes(state, name) {
      const tempArr = state.cachesRoutes || [];
      tempArr.push(name);
      state.cachesRoutes = tempArr;
    },
    setPlatform(state, data) {
      state.platform = data;
    },
    setRealPlatform(state, data) {
      state.realPlatform = data;
    }
  },
  actions: {}
};

export default app;



// WEBPACK FOOTER //
// ./src/store/modules/app.js